import {
    GET_GROUP_BY_ID_REQUEST,
    GET_GROUP_BY_ID_SUCCESS,
    GET_GROUP_BY_ID_FAILURE
} from '../actions';


const initialState = {};

const GetGroupByIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_GROUP_BY_ID_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_GROUP_BY_ID_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_GROUP_BY_ID_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default GetGroupByIdReducer;